import type { FC, ReactElement } from 'react';

import Logo from '../components/Logo/Logo';

import cx from 'classnames';
import s from './Template.module.scss';

export interface ITemplate {
  img?: boolean;
}

const Template: FC<ITemplate> = (props: ITemplate): ReactElement => {
  const { img } = props;
  return (
    <div className={cx(s.wrapper, img && s.fillWrapper)}>
      <Logo className={cx(s.logo, img && s.fillLogo)} maxHeight={img ? 10 : 4} />
      {!img && <div className={s.loader} />}
    </div>
  );
};

export default Template;
